export enum SortingEnum {
    DESC = 'desc',
    ASC = 'asc',
}
